import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Shop_Wise_NFSA_State_Sales_Details from "./Shop_Wise_NFSA_State_Sales_Details";
import progressGif from "../../images/progress.gif";

const Shop_Wise_NFSA_State_Dist_Sales = ({ nfsaType, month, year }) => {
  const [schemes, setSchemes] = useState([]);
  const [salesData, setSalesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [schemeLoading, setSchemeLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [showDistrictData, setShowDistrictData] = useState(false);

  const districtDetailsRef = useRef(null); 

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];
  const monthName = monthNames[month - 1] || "";

  useEffect(() => {
    if (!month || !year) return;

    const fetchData = async () => {
      setSchemeLoading(true);
      setLoading(true);
      setError("");
      setSchemes([]);
      setSalesData([]);

      try {
        const schemeRes = await axios.get(
          `${process.env.REACT_APP_URL}/api/fpsSales/schemes`,
          { params: { nfsaType, month, year } }
        );

        const fetchedSchemes = schemeRes.data || [];
        setSchemes(fetchedSchemes);

        if (fetchedSchemes.length === 0) {
          setSalesData([]);
          setError("No Data Found");
          return;
        }

        const requestBody = { nfsaType, schemes: fetchedSchemes, month, year };
        const salesRes = await axios.post(
          `${process.env.REACT_APP_URL}/api/fpsSales/distShopSale`,
          requestBody
        );

        const fetchedSales = salesRes.data || [];

        if (fetchedSales.length === 0) {
          setSalesData([]);
          setError("No Data Found");
        } else {
          const correctedSales = fetchedSales.map(row => {
            const correctedSchemeWiseSales = {};
            fetchedSchemes.forEach(s => {
              correctedSchemeWiseSales[s.schemeId] =
                row.schemeWiseSales?.[s.schemeId] ?? 0;
            });
            return { ...row, schemeWiseSales: correctedSchemeWiseSales };
          });
          setSalesData(correctedSales);
        }
      } catch (err) {
        console.error("❌ API Error:", err);
        setSchemes([]);
        setSalesData([]);
        setError("No Data Found");
      } finally {
        setSchemeLoading(false);
        setLoading(false);
      }
    };

    fetchData();
  }, [nfsaType, month, year]);

  const handleDistrictClick = (dist) => {
    if (selectedDistrict === dist) {
      setSelectedDistrict(null);
      setShowDistrictData(false);
      return;
    }

    setSelectedDistrict(dist);
    setShowDistrictData(false);
    setTimeout(() => {
    setShowDistrictData(true);

      setTimeout(() => {
        if (districtDetailsRef.current) {
          districtDetailsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100); 
    }, 1000);
  };

  const totals = {};
  schemes.forEach(s => {
    totals[s.schemeId] = salesData.reduce(
      (sum, row) => sum + (row.schemeWiseSales?.[s.schemeId] || 0),
      0
    );
  });

  const nfsaExtraTotal = nfsaType === "N"
    ? salesData.reduce((sum, row) => sum + (row.nfsaExtraQty || 0), 0)
    : 0;

  const grandTotal = salesData.reduce((sum, row) => sum + (row.total || 0), 0);

  const reportTitle = `Monthly Allotted Sales of Rice for ${
    nfsaType === "N" ? "NFSA" : "State"
  } in ${monthName} '${year}`;

  return (
    <div style={{ padding: 20, textAlign: "center" }}>
      {salesData.length > 0 && (
        <div
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "6px 0",
            width: "70%",
            margin: "0 auto",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          {reportTitle}
        </div>
      )}

      {(schemeLoading || loading) && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <img src={progressGif} alt="Loading..." width="250" height="15" />
        </div>
      )}

      {!schemeLoading && !loading && (error || salesData.length === 0) && (
        <p style={{ color: "red", fontWeight: "bold", marginTop: 20, fontSize: "20px" }}>
          No Data Found
        </p>
      )}

      {!schemeLoading && !loading && salesData.length > 0 && (
        <div
          style={{
            overflowX: "auto",
            marginTop: 0,
            width: "70%",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "100px",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ccc", fontSize: "14px" }}>
            <thead>
              <tr style={{ backgroundColor: "#000", color: "#fff" }}>
                <th rowSpan="2" style={{ padding: "4px 6px" }}>Sl No</th>
                <th rowSpan="2" style={{ padding: "4px 6px" }}>District</th>
                <th colSpan={schemes.length + (nfsaType === "N" ? 2 : 1)} style={{ padding: "4px 6px" }}>
                  {nfsaType === "N"
                    ? "NFSA (Quantity of Allotted Rice (Kg))"
                    : "State (Quantity of Allotted Rice (Kg))"}
                </th>
              </tr>
              <tr style={{ backgroundColor: "#222", color: "#fff" }}>
                {schemes.map(s => (
                  <th key={s.schemeId} style={{ padding: "4px 6px" }}>{s.schemeNameEn}</th>
                ))}
                {nfsaType === "N" && <th style={{ padding: "4px 6px" }}>NFSA Extra Qty</th>}
                <th style={{ padding: "4px 6px" }}>Total</th>
              </tr>
            </thead>
            <tbody>
              {salesData.map((row, idx) => (
                <tr key={idx}>
                  <td style={{ padding: "4px 6px", textAlign: "right" }}>{idx + 1}</td>
                  <td
  style={{
    padding: "4px 6px",
    textAlign: "left",
    color: "black",          
    textDecoration: "underline",
    cursor: "pointer",
    transition: "color 0.2s",
  }}
  onClick={() => handleDistrictClick(row.distCode)}
  onMouseEnter={(e) => {
    e.target.style.color = "red"; 
  }}
  onMouseLeave={(e) => {
    e.target.style.color = "black";
  }}
>
  {row.distNameEn}
</td>

                  {schemes.map(s => (
                    <td key={s.schemeId} style={{ padding: "4px 6px", textAlign: "right" }}>
                      {(row.schemeWiseSales[s.schemeId] || 0).toFixed(3)}
                    </td>
                  ))}
                  {nfsaType === "N" && (
                    <td style={{ padding: "4px 6px", textAlign: "right" }}>
                      {(row.nfsaExtraQty || 0).toFixed(3)}
                    </td>
                  )}
                  <td style={{ padding: "4px 6px", fontWeight: "bold", textAlign: "right" }}>
                    {(row.total || 0).toFixed(3)}
                  </td>
                </tr>
              ))}

              <tr style={{ backgroundColor: "#000", color: "#fff", fontWeight: "bold" }}>
                <td style={{ padding: "4px 6px", textAlign: "center" }} colSpan="2">Total</td>
                {schemes.map(s => (
                  <td key={s.schemeId} style={{ padding: "4px 6px", textAlign: "right" }}>
                    {totals[s.schemeId].toFixed(3)}
                  </td>
                ))}
                {nfsaType === "N" && (
                  <td style={{ padding: "4px 6px", textAlign: "right" }}>{nfsaExtraTotal.toFixed(3)}</td>
                )}
                <td style={{ padding: "4px 6px", textAlign: "right" }}>{grandTotal.toFixed(3)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {selectedDistrict && (
        <div
          ref={districtDetailsRef}
          style={{ marginTop: 30, width: "80%", marginLeft: "auto", marginRight: "auto", backgroundColor: "#fafafa" }}
        >
          {!showDistrictData ? (
            <div style={{ textAlign: "center", marginTop: "5px" }}>
              <img src={progressGif} alt="Loading..." width="250" height="15" />
            </div>
          ) : (
            <Shop_Wise_NFSA_State_Sales_Details
              nfsaType={nfsaType}
              month={month}
              year={year}
              distCode={selectedDistrict}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Shop_Wise_NFSA_State_Dist_Sales;
